export default __webpack_public_path__ + "media/images/clippy_frame-3446d4d28d72aef2f64f7fabae30eb4a.png";